import { makeMultiSearch, makeSearch } from "../../UI/Search/Search";
import AreaOfStudyTypeService from "../../../Services/AreaOfStudyType.service";
const makeSearchArgs = {
    loadOptions: (search, options) => AreaOfStudyTypeService.search({
        query: search,
        ids: options.ids,
        excludeIds: options.excludeIds,
    }).then(({ data }) => data),
    label: "name",
    value: "id",
};
export const AreaOfStudyTypeSearch = makeSearch(makeSearchArgs);
export const AreaOfStudyTypeMultiSearch = makeMultiSearch(makeSearchArgs);
